export const CHECKOUT_STEPS = {
  CART: 'cart',
  INFO: 'info',
  PAYMENT: 'payment',
};
